import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=04a61c91&scoped=true&"
import script from "./Papers.vue?vue&type=script&lang=js&"
export * from "./Papers.vue?vue&type=script&lang=js&"
import style0 from "./Papers.vue?vue&type=style&index=0&id=04a61c91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a61c91",
  null
  
)

export default component.exports